import script from "./transition-fade.vue?vue&type=script&setup=true&lang=ts"
export * from "./transition-fade.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__